module.exports = __webpack_public_path__ + "static/media/moot6d.790b65ff.JPG";